var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNonotice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 100,
    viewBox: "0 0 120 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60 99.4783C93.1371 99.4783 120 89.7453 120 77.7391C120 65.7329 93.1371 56 60 56C26.8629 56 0 65.7329 0 77.7391C0 89.7453 26.8629 99.4783 60 99.4783Z",
    fill: "#F9FAFB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M80.2184 11.2985L31.9933 16.3076C30.8924 16.422 30.0927 17.4071 30.207 18.5079L36.8026 82.0063C36.9169 83.1072 37.902 83.9069 39.0029 83.7926L87.228 78.7835C88.3289 78.6691 89.1286 77.684 89.0143 76.5832L82.4187 13.0847C82.3044 11.9839 81.3193 11.1842 80.2184 11.2985Z",
    fill: "#BDC6DB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M78.142 14.2292L34.6183 18.75C33.5174 18.8643 32.7177 19.8494 32.832 20.9503L38.7968 78.3764C38.9112 79.4773 39.8963 80.277 40.9971 80.1626L84.5209 75.6419C85.6218 75.5275 86.4215 74.5424 86.3071 73.4416L80.3423 16.0154C80.228 14.9146 79.2429 14.1149 78.142 14.2292Z",
    fill: "white",
    stroke: "#ADB5C2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M70.6329 17.0428L69.9564 10.5319C69.9225 10.2617 69.784 10.0156 69.5705 9.84638C69.3571 9.6772 69.0858 9.5985 68.8149 9.62719L60.7652 10.4728C60.6996 9.82317 60.5068 9.19284 60.1977 8.61777C59.8886 8.0427 59.4692 7.53414 58.9636 7.12114C58.4579 6.70814 57.8759 6.39877 57.2507 6.21071C56.6255 6.02265 55.9693 5.95958 55.3197 6.02509C54.6701 6.09061 54.0398 6.28343 53.4647 6.59254C52.8897 6.90166 52.3811 7.32101 51.9681 7.82667C51.134 8.84788 50.7398 10.1586 50.8721 11.4705L42.7969 12.3161C42.6609 12.3298 42.5288 12.3703 42.4084 12.4351C42.288 12.4999 42.1815 12.5879 42.0951 12.6939C42.0087 12.7999 41.9441 12.922 41.9049 13.053C41.8657 13.1841 41.8528 13.3215 41.8668 13.4576L42.5433 19.9684C42.557 20.1045 42.5974 20.2366 42.6623 20.357C42.7271 20.4774 42.8151 20.5839 42.9211 20.6703C43.0271 20.7567 43.1492 20.8213 43.2802 20.8605C43.4112 20.8997 43.5487 20.9126 43.6848 20.8986L69.7112 18.1928C69.8478 18.1791 69.9803 18.1384 70.1009 18.0729C70.2215 18.0074 70.3278 17.9185 70.4137 17.8114C70.4995 17.7043 70.5631 17.5812 70.6007 17.4492C70.6384 17.3172 70.6493 17.179 70.6329 17.0428Z",
    fill: "white",
    stroke: "#ADB5C2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M49.7051 56.7337C49.982 54.2245 51.1096 51.8858 52.9003 50.1065C54.6911 48.3272 57.037 47.2146 59.5478 46.9537C62.0587 46.6928 64.5832 47.2994 66.7015 48.6726C68.8197 50.0458 70.404 52.1027 71.1909 54.5014",
    stroke: "#ADB5C2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M50.9409 37.3701L46.8906 42.3589",
    stroke: "#ADB5C2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M46.4238 37.8438L51.4042 41.8855",
    stroke: "#ADB5C2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M70.5229 35.3408L66.4727 40.3212",
    stroke: "#ADB5C2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M66.0078 35.8057L70.9882 39.8559",
    stroke: "#ADB5C2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNonotice);
export default __webpack_public_path__ + "static/media/nonotice.444cccbb23cfe8cda555088d8f46c837.svg";
export { ForwardRef as ReactComponent };